import { render, staticRenderFns } from "./pcb_size.vue?vue&type=template&id=672c92ee&scoped=true"
import script from "./pcb_size.vue?vue&type=script&lang=js"
export * from "./pcb_size.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672c92ee",
  null
  
)

export default component.exports